<template>
<div class="popup" v-show="addUserShow||addItemShow" element-loading-background="rgba(0, 0, 0, 0.1)" v-cloak>
    <div id="batch-add-sub-account" class="content" >
        <div class="title">
            <span v-show="addUserShow">{{$t('language.popup.subAccountPopup.quickAdd')}}</span>
            <span v-show="addItemShow">{{$t('language.popup.subAccountPopup.quickAssign')}}</span>
            <div class="icon white-close dialog-close" @click="closeDialog()"></div>
        </div>
        <div class="batch-title">
            <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                <tr class="tab-th">
                    <th class="batch-th">
                        <div v-show="(addList.length==0||addItemId=='')&&addUserShow">{{$t('language.popup.subAccountPopup.batchAddUserNull')}}</div>
                        <div v-show="(addList.length==0||addItemId=='')&&addItemShow">{{$t('language.popup.subAccountPopup.batchAddItemNull')}}</div>
                        <div @click.stop="checkAll()" v-show="addList.length>0">
                            <div class="icon-util sub-check" :class="allSelect?'check-small':'nocheck-small'"></div>
                            <span v-show="addItemShow">{{$t('language.popup.subAccountPopup.folders')}}</span>
                            <span v-show="addUserShow">{{$t('language.popup.subAccountPopup.users')}}</span>
                        </div>
                    </th>
                </tr>
            </table>
        </div>
        <div class="batch-body" v-loading="loading">
            <el-scrollbar style="height:100%;" ref="subBatchAddScroll">
                <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                    <tr :key="index" v-for="(item,index) in addList" class="batch-tr">
                        <td class="batch-td">
                            <div class="batch-items" v-show="addItemShow" @click="checkBatchItems(item)">
                                <div class="icon-util sub-check" :class="selectItems.includes(item)?'check-small':'nocheck-small'"></div>
                                <div class="fName" :title="item.folderName">{{item.folderName}}</div>
                            </div>
                            <div class="batch-items" v-show="addUserShow" @click="checkBatchItems(item)">
                                <div class="icon-util sub-check" :class="selectItems.includes(item)?'check-small':'nocheck-small'"></div>
                                <div class="fName" :title="item.email">{{item.email}}</div>
                            </div>
                        </td>
                    </tr>
                </table>
            </el-scrollbar>
        </div>
        <div class="task-footer">
            <button class="task-button" @click="addBatchItems()" v-loading='okLoading'>{{$t('language.common.ok')}}</button>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import Utils from '@/js/request_util';
import commonstate from '@/js/constant.js';
export default {
    props:['allPermissionData'],//所有权限
    data: function () {
        return {
            user: commonstate.user,
            addUserShow: false,
            addItemShow: false,
            loading: false,
            okLoading: false,
            allSelect: false,
            addItem: {},//需要被批量添加的对象
            addList: [],//可以被批量添加的集合
            selectItems: [],//被选中的集合
            addItemId: "",//需要被批量添加的对象id
        }
    },
    mounted() {
    },
    watch:{
        addUserShow(val){
            if(val){
                this.addItemShow = false;
                this.initAddList()
            }
        },
        addItemShow(val){
            if(val){
                this.addUserShow = false;
                this.initAddList()
            }
        },
    },
    methods: {
        initData() {
            let that = this;
            this.loading = true;
            
        },
        closeDialog() {
            this.addItem = {};
            this.addItemId = "";
            this.allSelect = false;
            this.addUserShow = false;
            this.addItemShow = false;
            this.selectItems = [];
        },
        checkAll(){
            this.allSelect = !this.allSelect;
            if(this.allSelect){
                this.selectItems = this.addList;
            }else{
                this.selectItems = [];
            }
        },
        checkBatchItems(item){
            if (this.selectItems.includes(item)) {
                this.selectItems = this.selectItems.filter((v) => {
                    let t = false;
                    if(this.addItemShow){
                        t = (v.cloudId+v.folderId)==(item.cloudId+item.folderId);
                    }else if(this.addUserShow){
                        t = v.email == item.email;
                    }
                    return !t;
                })
            } else {
                this.selectItems.push(item);
            }
            //全选
            if(this.selectItems.length == this.addList.length){
                this.allSelect = true;
            }else{
                //非全选
                this.allSelect = false;
            }
        },
        initAddList(){
            if(this.addUserShow==this.addItemShow){
                return;
            }
            this.addItemId = "";
            let leftData = [];
            let isUnRepeat = true;
            this.allPermissionData.forEach(v => {
                isUnRepeat = true;
                for (let i = 0; i < leftData.length; i++) {
                    //重复时，添加权限到itemList
                    if(this.addItemShow){
                        //任意一个包含被添加的对象的权限id均可
                        if(v.emailId==this.addItem&&this.addItemId==""){
                            this.addItemId = v.id;
                        }
                        if(v.cloudId == leftData[i].cloudId && v.folderName == leftData[i].folderName){
                            if(v.email){
                                //v.name = v.email;//排序用
                                leftData[i].subList.push(v.email);
                            }
                            isUnRepeat = false;
                            break;
                        }
                    }else if(this.addUserShow){
                        //任意一个包含被添加的对象的权限id均可
                        if(v.cloudId==this.addItem.cloudId&&v.folderId==this.addItem.folderId&&this.addItemId==""){
                            this.addItemId = v.id;
                        }
                        if(v.emailId == leftData[i].emailId){
                            if(v.cloudId){
                                //v.name = v.folderName;//排序用
                                leftData[i].subList.push(v.cloudId+v.folderId);
                            }
                            isUnRepeat = false;
                            break;
                        }
                    }
                }
                //未重复时，添加到leftData
                if(isUnRepeat){
                    const item = {
                        id: v.id,
                        subList: [],
                    }
                    if(this.addItemShow){
                        //item.name = v.folderName;//排序用
                        item.folderName = v.folderName;
                        item.cloudId = v.cloudId;
                        item.cloudType = v.cloudType;
                        item.folderId = v.folderId;
                        //没有cloudId不添加
                        if(v.cloudId){
                            leftData.push(item);
                        }
                        if(v.emailId && v.cloudId){
                            //非空子账号权限加入权限栏
                            //v.name = v.email;//排序用
                            item.subList.push(v.emailId);
                        }
                        //任意一个包含被添加的对象的权限id均可
                        if(v.emailId==this.addItem&&this.addItemId==""){
                            this.addItemId = v.id;
                        }
                    }else if(this.addUserShow){
                        item.email = v.email;//排序用
                        item.emailId = v.emailId;
                        //没有email不添加
                        if(v.emailId){
                            leftData.push(item);
                        }
                        if(v.emailId && v.cloudId){
                            //非空子账号权限加入权限栏
                            //v.name = v.folderName;//排序用
                            item.subList.push(v.cloudId+v.folderId);
                        }
                        //任意一个包含被添加的对象的权限id均可
                        if(v.cloudId==this.addItem.cloudId&&v.folderId==this.addItem.folderId&&this.addItemId==""){
                            this.addItemId = v.id;
                        }
                    }
                }
            });
            let that = this;
            leftData = leftData.filter((v) => {
                let t = false;
                if(that.addItemShow){
                    t = v.subList.includes(that.addItem);
                }else if(this.addUserShow){
                    t = v.subList.includes(that.addItem.cloudId+that.addItem.folderId);
                }
                return !t;
            })
            this.addList = leftData;
            //根据name排序
            // leftData.forEach(function (item,index) {
            //     item.subList = commonUtils.sortJsonArrName(item.subList,true);
            // })
            // this.addList = commonUtils.sortJsonArrName(leftData,true);
        },
        addBatchItems(){
            if(this.selectItems.length==0||this.addItemId==""){
                this.closeDialog();
                return;
            }
            let data = {
                ud: commonstate.user.id,
                id: this.addItemId,
                type: this.addUserShow?"folder":"user",
                dels: [],
            }
            let adds = [];
            this.selectItems.forEach(function(item,index){
                adds.push(item.id);
            })
            data.adds = adds;
            this.okLoading = true;
            this.Utils.doPermissionRequest("add_list", data).then(res => {
                 this.okLoading = false;
                if(res.status=="200"){
                    this.$parent.getPermissionList();
                    this.closeDialog();
                }else{
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "batch-add-sub-account"
                    });
                }
            })
        },
    }
}
</script>

<style scope>
#batch-add-sub-account {
    width: 420px;
    /*no*/
    height: 450px;
    /*no*/
}

#batch-add-sub-account .batch-th,.batch-td{
    width: 100%;
    text-align: left;
    padding: 0 10px;/*no*/
}

#batch-add-sub-account .batch-title {
    margin: 10px;/*no*/
    margin-bottom: 0;
}

#batch-add-sub-account .batch-body {
    height: calc(100% - 180px);/*no*/
    margin: 0 5px 0 10px;/*no*/
}

#batch-add-sub-account .batch-items {
    border-width: 0 0 1px 0;/*no*/
    border-style: solid;
    border-color: #becae4;
    margin-right: 5px;/*no*/
    cursor: pointer;
}

#batch-add-sub-account .batch-items .fName{
    float: right;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 353px;/*no*/
    padding-right: 5px;/*no*/
}

#batch-add-sub-account .batch-tr {
    line-height: 38px;/*no*/
    font-size: 14px;/*no*/
}

#batch-add-sub-account .task-button .el-loading-spinner{
    top: 47px;/*no*/
}

#batch-add-sub-account .el-loading-spinner .circular{
    width: 20px;/*no*/
    height: 20px;/*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/popup/sub_account_popups/batch_add_popup.vue